'use client'

import React, { useCallback, useState } from 'react'
import { useTranslations } from 'next-intl'
import cn from 'classnames'

import shared from '@booking/index.module.scss'
import styles from './index.module.scss'

import SummaryBox from '@booking/components/SummaryBox'
import HelpBox from '@booking/components/HelpBox'
import BackButton from '@booking/components/BackButton'
import ContinueButton from '@booking/components/ContinueButton'

import { useBookingActionsCtx, useBookingState } from '@booking/state/booking.context'
import ExtrasSection from '../QuantitySelection/components/ExtrasSection'
import RockInRioExtrasGrid from './components/RockInRioExtrasGrid'
import RockInRioExtrasRows from './components/RockInRioExtrasRows'

function ExtrasRows() {
  return <ExtrasSection showTitle={false} />
}

const EXTRAS_COMPONENTS: Record<string, React.ComponentType> = {
  rows: ExtrasRows,
  'rock-in-rio': RockInRioExtrasGrid,
  'rock-in-rio-rows': RockInRioExtrasRows,
}

export default function ExtrasSelection() {
  const t = useTranslations('booking')

  const state = useBookingState()
  const { onCompleteExtrasSelection } = useBookingActionsCtx()

  const extrasConfig = state.config.extras
  const extrasTotal = state.extras.reduce((sum, e) => sum + e.quantity, 0)

  const ExtrasComponent = extrasConfig?.component
    ? (EXTRAS_COMPONENTS[extrasConfig.component] ?? null)
    : null

  const [showError, setShowError] = useState(false)

  const onContinue = useCallback(() => {
    if (extrasTotal === 0) {
      setShowError(true)
      return
    }
    setShowError(false)
    return onCompleteExtrasSelection()
  }, [extrasTotal, onCompleteExtrasSelection])

  return (
    <div className={cn(shared.box)}>
      <div className={cn(shared.inner)}>
        <div className={cn(shared.leftColumn)}>
          <div className={cn(styles.header)}>
            <BackButton />
            {extrasConfig?.titleKey && (
              <h2 className={cn(styles.title)}>{t(extrasConfig.titleKey)}</h2>
            )}
            {extrasConfig?.subtitleKey && (
              <p className={cn(styles.note)}>{t(extrasConfig.subtitleKey)}</p>
            )}
          </div>

          {showError && <div className={styles.errorHolder}>{t('extras.selectExtras.error')}</div>}

          {ExtrasComponent ? <ExtrasComponent /> : <ExtrasSection showTitle={false} />}

          <ContinueButton className={cn(shared.continue)} onContinue={onContinue} />
        </div>

        <div className={cn(shared.rightColumn)}>
          <SummaryBox onContinue={onContinue} />
          <HelpBox />
        </div>
      </div>
    </div>
  )
}
